import React from 'react';
import { Table, Button, Space, Tooltip, Popconfirm, Tag } from 'antd';
import { EditOutlined, DeleteOutlined, BankOutlined } from '@ant-design/icons';
import { formatClinicStatus } from '../../utils/helpers';

const ClinicsTable = ({ data, loading, onEdit, onDelete }) => {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 70,
      align: 'center',
    },
    {
      title: 'Clinic Name',
      dataIndex: 'name',
      key: 'name',
      render: (name) => <div style={{ fontWeight: 500 }}>{name || '-'}</div>,
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      ellipsis: true,
      render: (address) => (
        <Tooltip title={address}>
          {address || '-'}
        </Tooltip>
      ),
    },
    {
      title: 'City',
      dataIndex: 'city',
      key: 'city',
      width: 120,
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      width: 150,
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 100,
      render: (isActive) => (
        <Tag color={isActive ? 'success' : 'default'}>
          {isActive ? 'Active' : 'Inactive'}
        </Tag>
      ),
    },
    {
      title: 'Working Days',
      dataIndex: 'working_hours',
      key: 'working_hours',
      width: 150,
      render: (workingHours) => {
        if (!workingHours) return '-';

        const openDays = Object.values(workingHours).filter((day) => day.is_open).length;
        return (
          <Space>
            <BankOutlined />
            <span>{openDays} days/week</span>
          </Space>
        );
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 120,
      fixed: 'right',
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Edit">
            <Button
              type="default"
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEdit?.(record)}
            />
          </Tooltip>
          <Popconfirm
            title="Delete Clinic"
            description="Are you sure you want to delete this clinic?"
            onConfirm={() => onDelete?.(record.id)}
            okText="Yes"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Tooltip title="Delete">
              <Button type="default" danger size="small" icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      rowKey="id"
      pagination={false}
      scroll={{ x: 800 }}
      size="middle"
    />
  );
};

export default ClinicsTable;